const CustomerReturn = () => import('./customer-return/index.vue');
const CreateRepair = () => import('./customer-return/_pages/create.vue');

const DealerDelivery = () => import('./dealers-delivery/index.vue');
const DealerCollection = () => import('./dealers-collection/index.vue');
const CustomerCollection = () => import('./customer-collection/index.vue');
const ItemStatus = () => import('./item-status/index.vue');
const Dealers = () => import('./dealers/index.vue');
const NewDealer = () => import('./dealers/_pages/create.vue');
const DealerDetails = () => import('./dealers/_pages/view.vue');

export default [
    {
        path: '/repair/customer/return',
        component: CustomerReturn
    },
    {
        path: '/new-repair',
        component: CreateRepair
    },
    {
        path: '/repair/delivery/to/dealer',
        component: DealerDelivery
    },
    {
        path: '/repair/collection/from/dealer',
        component: DealerCollection
    },
    {
        path: '/repair/collection/by/customer',
        component: CustomerCollection
    },
    {
        path: '/repair/item/status',
        component: ItemStatus
    },
    {
        path: '/dealers',
        component: Dealers
    },
    {
        path: '/dealer/:id',
        component: DealerDetails
    },
    {
        path: '/new-dealer',
        component: NewDealer
    }
]